export const POPUP_MARGIN = 0.5;
